import React from "react";
import PayGoList from "../../../features/paygo/components/PaygoList";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import CreateNewPayGoBtnModal from "../../../features/paygo/components/NewPayGo/CreateNewPayGoBtn/CreateNewPayGoBtn";
import SinglePayGoModal from "../../../features/paygo/components/SinglePayGo/SinglePayGoModal/SinglePayGoModal";
import SinglePaygoPage from "../SinglePaygoPage/SinglePaygoPage";
import PageContent from "../../../common/components/atom/PageContent/PageContent";

export default function PaygoListPage() {
  return (
    <>
      <PageContent>
        <HeaderTitleContent>PayGo</HeaderTitleContent>
        <CreateNewPayGoBtnModal />
        <div style={{ height: 50 }} />
        <SectionTitle iconType={"coin"}>Liste des paygo</SectionTitle>
        <PayGoList.Filter />
        <PayGoList.List />
      </PageContent>
      <SinglePayGoModal>
        <SinglePaygoPage />
      </SinglePayGoModal>
    </>
  );
}
